import React from "react";
import Loader from "./Loader";
import EmptyState from "./EmptyState";
import Button from "../../ui/Button";
import Table from "../../ui/Table";

export default function TableWithState({
  columns = [],
  data = [],
  total = 0,
  limit = 20,
  offset = 0,
  sort,
  onSort,
  onPageChange,
  loading = false,
  error,
  rowKey = "id",
  onRowClick,
  emptyMessage = "No records found",
  renderActions,
}) {
  const currentPage = Math.floor(offset / limit) + 1;
  const totalPages = Math.max(1, Math.ceil(total / limit || 1));

  const [sortField, sortDir] = sort ? sort.split(":") : [null, null];
  const tableColumns = columns.map((col) => ({
    id: col.accessor,
    accessor: col.accessor,
    header: col.label,
    sortable: col.sortable,
  }));

  if (renderActions) {
    tableColumns.push({
      id: "__actions",
      header: "Actions",
      render: (row) => (
        <div onClick={(event) => event.stopPropagation()}>{renderActions(row)}</div>
      ),
    });
  }

  if (loading) {
    return (
      <div className="table-with-state">
        <Loader />
      </div>
    );
  }

  if (error) {
    return <div className="table-with-state error">Error: {error}</div>;
  }

  if (!loading && data.length === 0) {
    return <EmptyState title={emptyMessage} />;
  }

  return (
    <div className="table-with-state" data-testid="table-with-state">
      <Table
        columns={tableColumns}
        data={data}
        sortBy={sortField}
        sortDirection={sortDir || "asc"}
        onSort={(columnId, direction) => onSort?.(`${columnId}:${direction}`)}
        emptyState={emptyMessage}
        getRowKey={(row) => row[rowKey] ?? row.id ?? row.key}
        onRowClick={onRowClick}
        getRowProps={(row) => ({
          "data-testid": `table-row-${row[rowKey] ?? row.id ?? row.key ?? "row"}`,
        })}
      />
      <div className="pagination">
        <Button
          type="button"
          onClick={() => onPageChange && onPageChange(Math.max(0, offset - limit))}
          disabled={offset <= 0}
          variant="secondary"
        >
          Previous
        </Button>
        <span>
          Page {currentPage} of {totalPages}
        </span>
        <Button
          type="button"
          onClick={() =>
            onPageChange && onPageChange(Math.min((totalPages - 1) * limit, offset + limit))
          }
          disabled={offset + limit >= total}
          variant="secondary"
        >
          Next
        </Button>
      </div>
    </div>
  );
}
